export default "__VITE_ASSET__DSZtoOql__"